import { ref, watch, computed } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import router from '@/router/index'

// Notification

export default function useSubmissionList() {
  // Use toast
  const toast = useToast()
  const route = router.history.current

  const refChangiSubmissionsTable = ref(null)

  // Table Handlers
  const tableColumns = [
    {
      key: 'stringID',
      label: 'id',
      sortable: true,
    },
    {
      key: 'customerName',
      label: 'Customer',
      sortable: true,
    },
    {
      key: 'customerContact',
      label: 'Contact',
      sortable: true,
    },
    {
      key: 'agent',
      label: 'Agent Name/code',
      sortable: true,
    },
    {
      key: 'lot',
      label: 'Lot number',
      sortable: true,
    },
    {
      key: 'orderTotal',
      label: 'Order total',
      sortable: true,
    },
    {
      key: 'payableAmount',
      label: 'Total payable',
      sortable: true,
    },
    {
      key: 'createdAt',
      label: 'created on',
      sortable: true,
    },
    { key: 'actions' },
  ]
  const perPage = ref(route.query.perPage ?? process.env.VUE_APP_PER_PAGE_CONTENT)
  const totalSubmissions = ref(0)
  const currentPage = ref(route.query.page ?? 1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref(route.query.search ?? '')
  const sortBy = ref(route.query.sortBy ?? 'stringID')
  const isSortDirDesc = ref(route.query.sortDesc ? (route.query.sortDesc !== 'false') : true)
  const createdAtFilter = ref(route.query.createdAt || '')
  const statusFilter = ref([])
  if (Array.isArray(route.query.status)) {
    statusFilter.value = route.query.status
  } else if (route.query.status) {
    statusFilter.value = [route.query.status]
  }
  const toDeletedID = ref(null)
  const currentDataLength = ref(0)
  const itemListData = ref([])
  let initialLoad = true

  const dataMeta = computed(() => {
    const localItemsCount = refChangiSubmissionsTable.value ? refChangiSubmissionsTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalSubmissions.value,
    }
  })

  const refetchData = () => {
    refChangiSubmissionsTable.value.refresh()
  }

  // watch([searchQuery, idSearchQuery, statusFilter, createdAtFilter], () => {
  //   currentPage.value = 1
  //   refetchData()
  // }, { deep: true })

  // watch([currentPage], () => {
  //   refetchData()
  // }, { deep: true })

  const fetchSubmissions = () => {
    store
      .dispatch('app-changi-submissions/fetchSubmissions', {
        search: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        status: statusFilter.value,
        createdAt: createdAtFilter.value,
      },
      { root: true })
      .then(response => {
        const { submissions, total } = response.data
        itemListData.value = submissions
        currentDataLength.value = submissions.length
        // callback(submissions)
        totalSubmissions.value = total
        if (!initialLoad) {
          router.replace({
            query: {
              search: searchQuery.value,
              perPage: perPage.value,
              page: currentPage.value,
              sortBy: sortBy.value,
              sortDesc: isSortDirDesc.value,
              status: statusFilter.value,
              createdAt: createdAtFilter.value,
            },
          }).catch(() => {})
        }
        initialLoad = false
      })
      .catch(error => {
        toast({
          component: ToastificationContent,
          props: {
            title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  let timer = null
  watch([statusFilter, createdAtFilter], () => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      currentPage.value = 1
      fetchSubmissions()
    }, 1000)
  }, { deep: true })

  watch([searchQuery], (current, prev) => {
    const currentVal = current[0]
    const prevVal = prev[0]
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      if ((!currentVal && prevVal) || (currentVal && currentVal.length > 2)) {
        currentPage.value = 1
        fetchSubmissions()
      }
    }, 1000)
  }, { deep: true })

  watch([sortBy, perPage, isSortDirDesc, currentPage], () => {
    fetchSubmissions()
  }, { deep: true })

  fetchSubmissions()

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveStatusVariant = status => {
    if (status === 'published') return 'success'
    if (status === 'draft') return 'secondary'
    return 'primary'
  }

  return {
    fetchSubmissions,
    tableColumns,
    perPage,
    currentPage,
    totalSubmissions,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refChangiSubmissionsTable,

    resolveStatusVariant,
    refetchData,

    toDeletedID,
    currentDataLength,
    itemListData,

    // Extra Filters
    statusFilter,
    createdAtFilter,
  }
}
